angular
  .module('library', ['pb.core', 'components'])

  .run([
    '$filter',
    'Module',
    function($filter, Module) {
      var module = new Module();

      module.push({
        menu: {
          name: 'library',
          title: $filter('translate')('library.LIBRARIES'),
          icon: 'zmdi zmdi-view-list',
          link: 'root.app.simple.libraries'
        }
      });
    }
  ]);
